import type {
  GuardianAccessScope,
  GuardianRelationshipType,
  GuardianStatus,
} from '@/features/guardian/types';

export const RELATIONSHIP_LABELS: Record<GuardianRelationshipType, string> = {
  FATHER: 'Ayah',
  MOTHER: 'Ibu',
  GUARDIAN: 'Wali',
  CAREGIVER: 'Pengasuh',
  OTHER: 'Lainnya',
};

export const ACCESS_SCOPE_LABELS: Record<GuardianAccessScope, string> = {
  FULL_READ: 'Akses Penuh',
  LIMITED_READ: 'Akses Terbatas',
};

/**
 * ADR-025's Addendum, "LIMITED_READ Field Redaction Policy": LIMITED_READ
 * hides only Evaluation rubric scores, Evaluation teacher notes, and
 * Murajaah notes - Targets, Setoran, and individual Progress remain fully
 * visible. This copy must never overstate what is hidden.
 */
export const ACCESS_SCOPE_DESCRIPTIONS: Record<GuardianAccessScope, string> = {
  FULL_READ: 'Dapat melihat seluruh informasi belajar anak yang diizinkan untuk Wali.',
  LIMITED_READ:
    'Tetap dapat melihat target hafalan, setoran, dan progres anak. Skor penilaian rinci, catatan guru pada evaluasi, dan catatan murajaah disembunyikan.',
};

export const STATUS_LABELS: Record<GuardianStatus, string> = {
  INVITED: 'Menunggu',
  ACTIVE: 'Aktif',
  REVOKED: 'Dicabut',
};

export const RESTRICTED_FIELD_TEXT = 'Disembunyikan karena akses terbatas';
